import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_FIRST_NAME_INPUT_TYPE = 'postermywall-first-name-input';

export const POSTERMYWALL_FIRST_NAME_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_FIRST_NAME_INPUT_TYPE,
  inputName: 'first-name',
  dataMarkerAttribute: 'data-is-pmw-form-first-name-input',
  displayName: 'First Name',
  placeholder: 'Enter your first name here',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-first-name-input') !== null,
});
